(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["otss-lp-runtime"] && !Shopify.designMode) return;
  try {
    (() => {
  if (!document.body.dataset.variant || window.OTSSShopify) return;
  const fields = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_content', 'utm_term', 'gclid', 'fbclid'];
  const parameters = new URLSearchParams(location.search);
  const storageKey = 'otss.shopify.attribution.v1';
  let attribution = {};
  try { attribution = JSON.parse(sessionStorage.getItem(storageKey) || '{}'); } catch (_) {}
  if (!attribution || typeof attribution !== 'object' || Array.isArray(attribution)) attribution = {};
  const clean = {};
  const incomingCampaign = fields.some(name => parameters.has(name));
  for (const name of fields) {
    const value = incomingCampaign ? parameters.get(name) : attribution[name];
    if (typeof value === 'string') clean[name] = value.replace(/[\u0000-\u001f\u007f]/g, '').slice(0, 200);
  }
  try { sessionStorage.setItem(storageKey, JSON.stringify(clean)); } catch (_) {}
  const events = [];
  const record = (name, placement = '') => {
    const event = Object.freeze({ name, variant: document.body.dataset.variant,
      audience: document.body.dataset.audience, placement,
      timestamp: new Date().toISOString(), attribution: { ...clean },
      preview: Boolean(window.Shopify && (Shopify.designMode || Shopify.inspectMode)) || parameters.has('preview_theme_id') });
    events.push(event);
    if (events.length > 100) events.shift();
    document.dispatchEvent(new CustomEvent('otss:event', { detail: event }));
  };
  const fill = form => {
    for (const name of fields) {
      if (!clean[name]) continue;
      const key = 'properties[_' + name + ']';
      let input = Array.from(form.elements).find(element => element.name === key);
      if (!input) { input = document.createElement('input'); input.type = 'hidden'; input.name = key; form.appendChild(input); }
      input.value = clean[name];
    }
  };
  document.querySelectorAll('.otss-lp-form').forEach(fill);
  document.addEventListener('click', event => {
    const sample = event.target.closest('a[data-sample]');
    if (sample) record('sample_open', sample.dataset.placement || 'body');
    const buy = event.target.closest('[data-buy]');
    if (buy && !buy.disabled) record('purchase_cta_click', buy.dataset.placement || 'body');
  });
  document.addEventListener('submit', event => {
    if (event.target.matches('.otss-lp-form')) { fill(event.target); record('cart_add_submit', event.submitter?.dataset.placement || 'body'); }
  });
  window.OTSSShopify = Object.freeze({ events, attribution: Object.freeze(clean) });
  record('page_view');
})();
  } catch(e) { console.error(e); }
})();

})();
